import React from "react";
import { Marker } from "@react-google-maps/api";
import casaIcon from "../../../../assets/map/icons/casita.png";

export const createMarkerIcon = (tipo, iconMap) => {
  const tipoIcon = iconMap[tipo] || iconMap.farmacia;
  return {
    url: tipoIcon.icon,
    scaledSize: new window.google.maps.Size(25, 25),
    anchor: new window.google.maps.Point(tipoIcon.point[0], tipoIcon.point[1]),
  };
};

const MapaMultipleStaticMarkers = React.memo(function ({
  cab,
  icon,
  handleMouseOver,
  handleMouseOut,
  markers,
}) {
  return markers.map((marker) => {
    const lat = parseFloat(marker[cab.mapa_latitud]);
    const lng = parseFloat(marker[cab.mapa_longitud]);

    const markerIcon = createMarkerIcon(cab.mapa_marker_icono, icon);

    const handleMarkerClick = () => {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
      );
    };

    return (
      <Marker
        key={marker._key}
        position={{ lat, lng }}
        icon={markerIcon}
        // onClick={handleMarkerClick}
        onMouseOver={(e) =>
          cab.mapa_OnMouseOver === "s" && handleMouseOver(marker, e, cab)
        }
        onMouseOut={() => cab.mapa_OnMouseOver === "s" && handleMouseOut()}
        onClick={(e) => {
          cab.mapa_OnMouseOver !== "s" && handleMouseOver(marker, e, cab);
        }}
      />
    );
  });
});

export default MapaMultipleStaticMarkers;
